import { LOAD_TYPE } from '$lib/constants/load';

/**
 * Assignment Registry — single source of truth for load-to-hardware compatibility.
 *
 * Each hardware source (RCU or DIN module type) declares which load types it accepts.
 */
export const ASSIGNMENT_REGISTRY = {
	rcu: {
		label: 'RCU Relay Output',
		compatible_load_types: [LOAD_TYPE.RELAY]
	},
	phase_cut: {
		label: '4ch Forward Phase Cut',
		compatible_load_types: [LOAD_TYPE.PHASE_CUT]
	},
	'1-10v': {
		label: '4ch 0-10V Dimmer',
		compatible_load_types: [LOAD_TYPE.ONE_TEN_V]
	},
	dali_master: {
		label: 'DALI Master',
		compatible_load_types: [LOAD_TYPE.DALI_DT6, LOAD_TYPE.DALI_DT8]
	},
	curtain: {
		label: 'Curtain Controller (legacy)',
		compatible_load_types: [LOAD_TYPE.CURTAIN]
	},
	relay: {
		label: 'Relay Module (legacy)',
		compatible_load_types: [LOAD_TYPE.RELAY]
	}
} as const;

export type AssignmentSource = keyof typeof ASSIGNMENT_REGISTRY;

/** Get load types compatible with a DIN module type. */
export function compatibleLoadTypesForDin(moduleType: string): string[] {
	if (moduleType in ASSIGNMENT_REGISTRY && moduleType !== 'rcu') {
		const info = ASSIGNMENT_REGISTRY[moduleType as AssignmentSource];
		return [...info.compatible_load_types];
	}
	return [];
}
